<!-- Download Agreement Modal -->
<div class="modal-header gtm-download-agreement selenium-download-agreement">
    <h5 class="modal-title">Download Agreement</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    Do you accept the terms and conditions as
    <a
        target="_blank"
        rel="noopener noreferrer"
        href="/help/full-license-for-section-3c-of-terms-of-use-download-and-share/"
        >outlined in this license?</a
    >
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-secondary selenium-download-close"
        (click)="activeModal.dismiss('Cross click')"
    >
        Close
    </button>
    <a
        class="btn btn-primary selenium-download-accept"
        href="{{ downloadUrl }}"
        (click)="activeModal.close()"
        >Accept</a
    >
</div>
